import React from 'react';
import { Truck, RotateCcw, ShieldCheck, Headphones } from 'lucide-react';

const ValueProps = () => {
  const features = [
    {
      icon: <Truck className="w-5 h-5 text-[#4A0E17]" />,
      title: "Complimentary Delivery",
      desc: "Insured express delivery across India",
      badge: "Express Shipping",
    },
    {
      icon: <RotateCcw className="w-5 h-5 text-[#4A0E17]" />,
      title: "Handloom Promise",
      desc: "100% authentic silk & genuine gems",
      badge: "Certified Pure",
    },
    {
      icon: <ShieldCheck className="w-5 h-5 text-[#4A0E17]" />,
      title: "Secure Checkout",
      desc: "256-bit SSL encrypted transactions",
      badge: "100% Safe",
    },
    {
      icon: <Headphones className="w-5 h-5 text-[#4A0E17]" />,
      title: "Atelier Concierge",
      desc: "Personal styling & order assistance",
      badge: "VIP Assistance",
    },
  ];

  return (
    <section className="bg-[#F4EFE6] border border-[#E8DFC8] rounded-3xl p-6 sm:p-8 md:p-10 mb-12 shadow-sm relative overflow-hidden">
      
      {/* Decorative Subtle Background Accent */}
      <div className="absolute -top-12 -right-12 w-40 h-40 bg-[#4A0E17]/5 rounded-full blur-2xl pointer-events-none" />

      {/* Grid for Tablet/Desktop | Horizontal Swipe Carousel for Mobile */}
      <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory scrollbar-none -mx-2 px-2 sm:mx-0 sm:px-0">
        {features.map((item, idx) => (
          <div 
            key={idx} 
            className="flex-shrink-0 w-[240px] sm:w-auto snap-center bg-[#FDFBF7]/90 backdrop-blur-md border border-[#E8DFC8] rounded-2xl p-4 sm:p-5 hover:border-[#4A0E17]/40 hover:shadow-md transition-all duration-300 group flex flex-col justify-between"
          >
            <div>
              {/* Top Row: Icon + Badge */}
              <div className="flex items-center justify-between mb-4">
                <div className="p-3 bg-[#F4EFE6] border border-[#E8DFC8] rounded-xl group-hover:bg-[#4A0E17] transition-colors duration-300">
                  {React.cloneElement(item.icon, {
                    className: "w-5 h-5 text-[#4A0E17] group-hover:text-[#FDFBF7] transition-colors duration-300"
                  })}
                </div>
                <span className="text-[9px] font-bold tracking-widest uppercase bg-[#4A0E17]/10 text-[#4A0E17] px-2.5 py-1 rounded-full border border-[#4A0E17]/20">
                  {item.badge}
                </span>
              </div>

              {/* Text Info */}
              <h4 className="text-xs sm:text-sm font-serif font-bold text-[#4A0E17] tracking-tight group-hover:text-[#6B1320] transition-colors duration-200">
                {item.title}
              </h4>
              <p className="text-[11px] sm:text-xs text-[#544842] mt-1 font-light leading-relaxed">
                {item.desc}
              </p>
            </div>

            {/* Bottom Accent Line */}
            <div className="w-8 h-[2px] bg-[#4A0E17]/20 group-hover:w-full group-hover:bg-[#4A0E17] transition-all duration-300 rounded-full mt-4" />
          </div>
        ))}
      </div>

    </section>
  );
};

export default ValueProps;